<template>
    <div class="row">
        <div class="col-md-12">
            <form>
                <div class="form-group" :class="{'has-error': form.errors.has('header')}">
                    <label class="control-label margin-bottom-10" v-text="$lang.get('trans.header')"></label>
                    <div class="pull-right">
                        <toggle-button v-model="form.has_header" color="#000000" :labels="{checked: $lang.get('trans.with_header'), unchecked: $lang.get('trans.no_header')}" :width="97" :height="28" :sync="true"/>
                    </div>
                    <template-section v-model="form.header" type="header" v-if="form.has_header"> </template-section>
                    <hr v-else>
                    <span class="help-block" v-if="form.errors.has('header')" v-text="form.errors.get('header')"></span>
                </div>

                <div class="form-group" :class="{'has-error': form.errors.has('body')}">
                    <label class="control-label margin-bottom-10" v-text="$lang.get('trans.body')"></label>
                    <template-section v-model="form.body" type="body"> </template-section>
                    <span class="help-block" v-if="form.errors.has('body')" v-text="form.errors.get('body')"></span>
                </div>

                <div class="form-group" :class="{'has-error': form.errors.has('footer')}">
                    <label class="control-label margin-bottom-10" v-text="$lang.get('trans.footer')"></label>
                    <div class="pull-right">
                        <toggle-button v-model="form.has_footer" color="#000000" :labels="{checked: $lang.get('trans.with_footer'), unchecked: $lang.get('trans.no_footer')}" :width="93" :height="28" :sync="true"/>
                    </div>
                    <template-section v-model="form.footer" type="footer" v-if="form.has_footer"> </template-section>
                    <hr v-else>
                    <span class="help-block" v-if="form.errors.has('footer')" v-text="form.errors.get('footer')"></span>
                </div>

                <div class="form-group">
                    <button class="btn btn-outine dark" @click.prevent="save">
                        <i class="glyphicon glyphicon-save"></i> Save
                    </button>
                </div>
            </form>

        </div>
    </div>
</template>

<script>
    import Form from 'services/form/Form'
    import TemplateSection from '../template-manager/TemplateSection'

    export default {
        name: "template-adjustments",

        components: {
            TemplateSection
        },

        props: {
            template: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                form: new Form({
                    header: null,
                    body: null,
                    footer: null,
                    has_header: false,
                    has_footer: false
                })
            }
        },

        methods: {
            async save() {
                try {
                    let response = await this.form.post(Sincron.steps.adjustTemplate)
                    this.$toaster.success(response.message)
                } catch (error) {
                    this.$toaster.error("Error saving the template adjustments!")
                }
            }
        },

        beforeMount() {
            this.form.header = this.template.header
            this.form.body = this.template.body
            this.form.footer = this.template.footer
            this.form.has_header = this.template.has_header
            this.form.has_footer = this.template.has_footer
        }
    }
</script>
